import React, { useState, useEffect } from 'react'
import AttendanceListTable from './components/AttendanceListTable'
import PageBody from "Common/Custom/PageBody";
import { toast } from "react-hot-toast";
import { HeadingOne } from "Common/Custom/HeadingOne";
import { checkInAttendance, checkOutAttendance, getAllEmployees } from "adminApi/HumanResources/Attendance";
import AddItemBtn from 'Common/Custom/AddItemBtn';
import FormSelect from 'Common/Custom/FormSelect';

const AttendanceList = () => {
    const [employees, setEmployees] = useState([]);
    const [selectedEmp, setSelectedEmp] = useState("");
    const [loading, setLoading] = useState(false);
    const [refreshTrigger, setRefreshTrigger] = useState(0);

    useEffect(() => {
        const fetchEmployees = async () => {
            const res = await getAllEmployees();
            if (res.data.success) {
                setEmployees(res.data.data || []);
            }
        };
        fetchEmployees();
    }, []);

    const handleQuickAction = async (action) => {
        if (!selectedEmp) {
            toast.error("Please select an employee first");
            return;
        }
        setLoading(true);
        try {
            const res = action === 'in' ? await checkInAttendance(selectedEmp) : await checkOutAttendance(selectedEmp);
            if (res.success) {
                toast.success(res.message || `Successfully checked ${action}`);
                setRefreshTrigger(prev => prev + 1);
            } else {
                toast.error(res.error || `Failed to check ${action}`);
            }
        } catch (err) {
            toast.error("An error occurred");
        } finally {
            setLoading(false);
        }
    };

    return (
        <PageBody
            card={true}
            headerchildren={
                <div className="d-flex justify-content-between align-items-center w-100 flex-wrap gap-3">
                    <HeadingOne className="mb-0">Attendance List</HeadingOne>

                    <div className="d-flex flex-wrap align-items-center gap-2">
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                            <div style={{ minWidth: '250px' }}>
                                <FormSelect
                                    field={{
                                        name: "employee_id",
                                        placeholder: "Select Employee",
                                        labelHide: true,
                                        fieldSize: "col-auto mb-0"
                                    }}
                                    value={selectedEmp}
                                    handleChange={(e) => setSelectedEmp(e.target.value)}
                                    options={employees.map(emp => ({
                                        value: emp.employee_id,
                                        label: `${emp.first_name} ${emp.last_name}`
                                    }))}
                                />
                            </div>
                            <button
                                className="btn btn-success"
                                onClick={() => handleQuickAction('in')}
                                disabled={loading}
                            > Check-In </button>
                            <button
                                className="btn btn-danger"
                                onClick={() => handleQuickAction('out')}
                                disabled={loading}
                            > Check-Out </button>
                        </div>

                        <AddItemBtn url="attendance-add" title="Add Attendance" />
                    </div>
                </div>
            }>

            {/* Table section */}
            <div className="col-12">
                <AttendanceListTable refreshTrigger={refreshTrigger} />
            </div>
        </PageBody>
    );
};

export default AttendanceList;
